import { h} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';
import { WidgetHelper } from '../../widgets/utils/widgetHelper';

export const Computation = props => {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);

  if(!item || !item.value || !item.value.id || item.answerType !== "Computation") {
    return (""); //defensive check
  }
  let computationBlock = (searchResp.computation && searchResp.computation.id === item.value.id) ? searchResp.computation : null;
  if(computationBlock === null) {
    return (""); //defensive check
  }
  return (
    <div className="computation-block">
      <div className="ae-para computation-equation">
        {computationBlock.expression} =
      </div>
      <div className="ae-headline computation-answer">
        {computationBlock.value}
      </div>
    </div>
  )
}
export const Translation = props => {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);

  if(!item || !item.value || !item.value.id || item.answerType !== "Translations") {
    return (""); //defensive check
  }
  let translationBlock = (searchResp.translations && searchResp.translations.id === item.value.id) ? searchResp.translations : null;
  if(translationBlock === null) {
    return (""); //defensive check
  }
  let descContract = <span>{translationBlock.contractualRules.map(cr => {
    if(cr._type === "ContractualRules/LicenseAttribution") {
      return (
        <span><a href={cr.license.url}>{cr.license.name}</a> &nbsp;</span>
      )
    } else if(cr._type === "ContractualRules/LinkAttribution") {
      return (
        <span><a href={cr.url}>{cr.text}</a></span>
      )
    } 
  })}</span>

  return (
    <div className="translation-block">
      <div className="translation-header">
        <div className="ae-para translation-header-text" style={{float:'left'}}>{translationBlock.inLanguage}</div>
        <div className="ae-para translation-header-text" style={{float:'right'}}>{translationBlock.translatedLanguageName}</div>
      </div>
      <div className="translation-result">
        <div className="ae-para-large translation-text">{translationBlock.originalText}</div>
        <div className="translation-contract">
          <div className="ae-subheadline translation-icon"><i className="arrow right icon"/></div>
          <div className="ae-caption">{descContract}</div>
        </div>
        <div className="ae-para-large translation-text">{translationBlock.translatedText}</div>
      </div>
    </div>
  )
}
